export default __webpack_public_path__ + "static/android-7443fa-1c6b0d227680beefddea46b4442f3c39.png";